export default {
  guest: {
    earn_pts: 'Guadagna {{points}} pt su questo ordine',
    tagline: 'Ricevi premi. Ad ogni ordine, ogni volta.',
    pick_reward: 'Scegli cosa vuoi quando ci arrivi',
    free_at: 'gratis a {{points}} pt',
    save_at: 'risparmia {{amount}} a {{points}} pt',
    nearest: 'più vicino',
    cta: 'Inizia a guadagnare — è gratis',
    already_member: 'Sei già membro?',
    sign_in: 'Accedi',
  },
  member: {
    earning_free: 'Stai guadagnando cibo gratuito',
    every_euro_one: 'Ogni {{amount}} spesi = 1 pt. Riscatta per articoli gratuiti e sconti.',
    every_euro_other: 'Ogni {{amount}} spesi = {{count}} pt. Riscatta per articoli gratuiti e sconti.',
    until_redeem: '{{remaining}} pt prima di poter riscattare',
    unlock_first: 'Solo questo ordine sblocca il tuo primo premio!',
    so_close: 'Così vicino al cibo gratuito!',
    just_more: 'Solo altri {{remaining}} pt e puoi iniziare a risparmiare.',
    pts_to_unlock: '{{remaining}} pt per sbloccare i premi',
    this_order_unlocks: 'Questo ordine ti porta a {{points}} pt — puoi riscattare al prossimo ordine!',
    save_next: 'Risparmia fino a {{amount}} la prossima volta',
    pts_from_order: '+{{earned}} pt da questo ordine — ne mancano solo {{remaining}}!',
    rewards_value: '= {{amount}} in premi',
    save_this_order: 'Risparmia fino a {{amount}} su questo ordine',
    use_pts: 'Usa i tuoi {{points}} pt al momento del pagamento',
    earned_this_order: '+{{points}} pt guadagnati su questo ordine',
    current: 'Corrente',
    from_this_order: '+{{points}} da questo ordine',
    expiration_zero: '{{points}} pt scadono oggi',
    expiration_one: '{{points}} pt scadono tra 1 giorno',
    expiration_other: '{{points}} pt scadono tra {{count}} giorni',
  },
};
